
define('modules/application/wizard/classes/exportProjectFile',[
  "app",

  // Libs
  "backbone",

  //Classes
  "./exportElement"

],

function(app, Backbone, exportElement) {

  var exportProjectFile    = _.extend({}, exportElement, {

    Views : {
      titleBar  : exportElement.Views.titleBar.extend({
        afterRender  :  function() {
          this.$el.children(".titleBarcontent").prepend($.i18n._("IDS_WTR1002_9006"));
        }
      }),
      content   : exportElement.Views.content.extend()
    },

    Model       : exportElement.Model.extend({})
  });

  // Required, return the module for AMD compliance
  return exportProjectFile;

});